import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_3106_2638",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .837952,
				width: 18,
				height: 20,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .837952,
			width: 18,
			height: 20,
			rx: 1,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 3,
			mask: "url(#path-1-inside-1_3106_2638)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.20649,
			y: 5.36854,
			width: 9.73349,
			height: .737075,
			rx: .368538,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .737075
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.20649,
			y: 8.36854,
			width: 9.73349,
			height: .737075,
			rx: .368538,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .737075
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.20649,
			y: 11.3685,
			width: 9.73349,
			height: .737075,
			rx: .368538,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .737075
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.20649,
			y: 14.3685,
			width: 9.73349,
			height: .737075,
			rx: .368538,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .737075
		})
	]
});
export default SvgActivityIcon;
